import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { Modal } from '@shared/components/modal';
import { useModals } from '@shared/contexts/modal-context';

import { ModalName } from '../types';
import * as Styled from './bonus-modal.styled.ts';

const BonusModal = () => {
	const { isModalOpen, closeModal } = useModals();
	const { t } = useTranslation('bonus_reg_rules');

	return (
		<Modal isOpen={isModalOpen(ModalName.BONUS)} title={t('header')} closeModal={closeModal}>
			<Styled.Wrapper>
				<p className={'justify'}>
					<strong>{t('justify')}</strong>
				</p>
				<ul>
					<li>{t('li_1')}</li>
					<li>{t('li_2')}</li>
					<li>{t('li_3')}</li>
					<li>{t('li_4')}</li>
				</ul>
				<br />
				<p>
					<b> {t('header_2')}</b>
				</p>

				<ul>
					<li>{t('li_5')}</li>
				</ul>
			</Styled.Wrapper>
		</Modal>
	);
};

export default BonusModal;
